import {
  Component,
  ElementRef,
  Inject,
  OnInit,
  Optional,
  ViewChild,
} from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { EMPTY, Observable, of } from 'rxjs';
import {
  catchError,
  debounceTime,
  distinctUntilChanged,
  map,
  startWith,
  switchMap,
} from 'rxjs/operators';
import { GroupSharingService } from '../../group-sharing/group-sharing.service.component';
import { COMMA, ENTER, I } from '@angular/cdk/keycodes';
import { ActivatedRoute, Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { HotToastService } from '@ngneat/hot-toast';
import { SpotlightService } from 'src/app/core/services/spotlight.service';
import { StripePurchaseService } from '../stripe-purchase.service';
import { UserDetailsService } from 'src/app/core/services/user-details/user-details.service';
import {
  IEventPurchaseDetails,
  IStripeEventPrice,
} from '../models/bulk-purchase.models';
import { error } from 'console';
import { EventType } from '../../passport/models/passport.models';
import { StripeConfirmationPopupComponent } from './stripe-confirmation-popup/stripe-confirmation-popup.component';
import { AuthenticationService } from 'src/app/core/services/Authentication/authentication.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { MyTicketsComponent } from 'src/app/shared/cinejoy/common/my-tickets/my-tickets.component';

export interface User {
  name: string;
  value: string;
  id: string;
  userId: string;
}

@Component({
  selector: 'app-stripe-purchase-popup',
  templateUrl: './stripe-purchase-popup.component.html',
  styleUrls: ['./stripe-purchase-popup.component.scss','./checkmark-animation.css'],
})
export class StripePurchasePopupComponent implements OnInit {
  constructor(
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<StripePurchasePopupComponent>,
    public groupSharingService: GroupSharingService,
    private _snackBar: MatSnackBar,
    private router: Router,
    private toast: HotToastService,
    public spotlightService: SpotlightService,
    private route: ActivatedRoute,
    private readonly bulkPurchaseService: StripePurchaseService,
    private readonly userService: UserDetailsService,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    private authService: AuthenticationService,
      private modalService: NgbModal,

  ) {}
  filteredOptions: any;
  options: User[] = [];
  myControl = new FormControl();
  invitationEmail = new FormControl('', Validators.email);
  emptyTicketCount: FormControl = new FormControl();
  invitedEmails: string[] = [];
  selectedUsers: any = [];
  invalidUsers:any=[];
  selectedUsersIds: any = [];
  @ViewChild('userInput') userDetailsInput: ElementRef<HTMLInputElement>;
  separatorKeysCodes: number[] = [ENTER, COMMA];
  eventId: string;
  invalidUserIds: boolean = false;
  loading = false;
  error = false;
  isConfirmationError= false;
  cinejoyPremierDetails: any;
  userDetails: any;
  filterHasLength = true;
  paymentResponse: any;
  ticketGuests: any[] = [];
  eventPurchaseDetails: IEventPurchaseDetails;
  eventPrice: IStripeEventPrice;
  pageUrl = '';
  puchaseType: string;
  subscriptionDetails:any;
  isButtonClicked:boolean=false;
  ngOnInit(): void {
    this.authService.checkUserAuthenticated().subscribe((res)=>{
      if(res.userId === 0){
        alert("Please login to Creatics to purchase tickets.")
        this.loading=false;
        this.error=false;
      }},
      (err)=>{}
      )

    if(this.data.puchaseType!='subscription'){
      this.getPremierInfo();
      this.getUserDetails();
    }
    else if (this.data.mode=='callback'){
      this.loading=true;
      this.handlePaymentCallback();
    }
    else {
      this.getUserDetails();
      this.loading=true;
      this.bulkPurchaseService.getSubscriptionDetails(this.data.purchaseTransactionType).subscribe(
        {next:(data:any)=>{
          this.subscriptionDetails=data;
          this.loading=false;
          this.error=false;
        },
        error:(error)=>{
          console.log("Got Subcription detail error----->", error);
          this.error=true;
          this.loading=false;
        }
      }
      );

    }
    this.puchaseType = this.data.puchaseType;
    this.pageUrl = this.data.url;
    this.filteredOptions = this.myControl.valueChanges.pipe(
      startWith(''),
      debounceTime(400),
      distinctUntilChanged(),
      switchMap((val) => {
        return this.filter(val || '');
      })
    );
    // this.populateCallbackUrl();
    console.log('--------------Url triggered------------', this.pageUrl);
  }

  get cinejoyEventName() {
    if (this.data.eventType === EventType.SPOTLIGHT) {
      return this.cinejoyPremierDetails.name;
    }
    return this.data.showcaseEvent.eventName;
  }

  closeDialog() {
    if(this.isButtonClicked){
      return;
    }
    this.dialogRef.close();
  }
  closeConfirmationDialog() {
    const pageUrl = new URL(window.location.href);
    pageUrl.searchParams.delete('session_id');
    // console.log(pageUrl)
    window.history.replaceState({}, '', pageUrl.toString());
    // window.location.reload();
    this.dialogRef.close();
  }

  inviteUser($event: any) {
    $event.stopImmediatePropagation();
    if (!this.invitationEmail.valid) {
      return;
    }
    if (this.invitedEmails.includes(this.invitationEmail.value)) {
      this.openSnackBar('User already added for invitation', '');
      return;
    }
    this.invitedEmails.push(this.invitationEmail.value);
    this.invitationEmail.setValue('', { emitEvent: true });
    this.myControl.reset('', { emitEvent: true });
  }

  removeInvitation(email: string) {
    this.invitedEmails.splice(
      this.invitedEmails.findIndex((emailEntry) => emailEntry === email),
      1
    );
  }

  initiateBulkPurchase(eventType:EventType) {
    if(this.isButtonClicked){
      return;
    }
    this.isButtonClicked=true;
    this.bulkPurchaseService
      .startPaymentSession(
        Number(this.data.eventId)||0,
        eventType,
        this.selectedUsersIds||[],
        this.emptyTicketCount.value || 0,
        this.pageUrl,
        this.data.purchaseTransactionType
      )
      .subscribe({
        next: (res) => {
          res.ineligibleGuestUserIds.map(id=>{
            this.selectedUsers.map(user=>{
              if(user.id===id){
                this.invalidUsers.push(user);
              }
            })
          })
          this.openStripeConfirmationPopup(res.paymentUrl, this.invalidUsers);
          this.isButtonClicked=false;
        },
        error: (err) => {
          if(err===401 || err===403){
            this.isButtonClicked=false;
            alert("Please login to creatics to purchase tickets."); // added this alert as in case of API failure user not getting error details
          }
          this.isButtonClicked=false;
      }
      }
      );
  }
  openStripeConfirmationPopup(url:string, invalidUsers): void {
    this.dialog.open(StripeConfirmationPopupComponent, {
      // panelClass: 'pre-schedule-modalbox',
      width: '500px',
      minHeight: '15%',
      maxHeight:'50%',
      position:{
        top:'20px'
      },
      data: {
        paymentUrl:url,
        invalidUsers:invalidUsers,
        guestUsers:+(this.selectedUsers.length-this.invalidUsers.length),
        emptyTicketCount:this.emptyTicketCount?this.emptyTicketCount.value:0,
        ticketPrice:this.eventPrice?this.eventPrice.ticketAmount:0 ,
        purchaseTransactionType:this.data.purchaseTransactionType

      }
    }).afterClosed().subscribe((res) => {
      this.invalidUsers=[];
      console.log('===== dialog closed with response: ', res);
    })
  }
  filter(val: string): Observable<any[]> {
    this.invitationEmail.setValue(this.myControl.value, {
      onlySelf: true,
      emitEvent: true,
    });
    if (val.length > 3) {
      return this.groupSharingService.getPublicUsersList(val).pipe(
        map((response) =>
          response.filter((option) => {
            let item: any = '';
            if (localStorage.getItem('userData')) {
              item = JSON.parse(localStorage.getItem('userData'));
            }
            return (
              option.userId != item.userId &&
              !this.selectedUsers.find((p) => p.id == option.userId)
            );
          })
        ),
        catchError((error) => {
          console.error('Error fetching user', error);
          return of([]);
        }),
        map((response) => {
          this.filterHasLength = !!response.length;

          if (
            this.invitationEmail.value &&
            !this.filterHasLength &&
            this.invitationEmail.valid
          ) {
            this.toast.info(
              `User not found on the Creatics Platform.`,
              {
                theme: 'snackbar',
                position: 'top-right',
                duration: 3000,
              }
            );
          }
          return response;
        })
      );
    }
    return EMPTY;
  }

  add(event): void {
    const value = (event.value || '').trim();
    if (value) {
      this.selectedUsers.push(value);
    }
    this.myControl.setValue(null);
  }

  remove(user: string): void {
    const index = this.selectedUsers.indexOf(user);
    const idIndex = this.selectedUsers.indexOf(user);
    if (index >= 0) {
      this.selectedUsers.splice(index, 1);
      this.selectedUsersIds.splice(idIndex, 1);
    }
  }

  selectedItems(event): void {
    console.log(this.selectedUsers, "users selected");
    if (!this.selectedUsers.find((v) => v.id == event.option.value)) {
      this.selectedUsersIds.push(event.option.value);
      this.selectedUsers.push({
        id: event.option.value,
        name: event.option.viewValue,
      });
      this.filteredOptions = this.myControl.valueChanges.pipe(
        startWith(''),
        debounceTime(400),
        distinctUntilChanged(),
        switchMap((val) => {
          return this.filter(val || '');
        })
      );
    } else {
      this.openSnackBar('User already selected', '');
    }

    this.userDetailsInput.nativeElement.value = '';
    this.myControl.setValue(null);
  }

  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 5000,
      horizontalPosition: 'end',
      verticalPosition: 'top',
    });
  }

  getPremierInfo() {
    Promise.all([
      this.bulkPurchaseService
        .getEventPurchaseDetails(this.data.eventId, this.data.eventType)
        .toPromise(),
      this.data.eventType === 'SHOWCASE'
        ? Promise.resolve(this.data.showcaseEvent)
        : this.spotlightService.cmsGetPremierdeatails(this.data.eventId).toPromise()
    ])
      .then(([eventPurchaseDetails, premiereDetails]) => {
        this.cinejoyPremierDetails = premiereDetails;
        this.eventPurchaseDetails = eventPurchaseDetails;
        this.eventPurchaseDetails.eventPrices.sort(
          (price1, price2) => price1.lower - price2.lower
        );
        this.eventPrice = this.eventPurchaseDetails.eventPrices[0];
        console.log('-----------1 -----------');
        this.handlePaymentCallback();
        this.loading = false;
        this.error = false;
        console.log('-----------2 -----------');
      })
      .catch((error) => {
        console.error(error);
        this.loading = false;
        this.error = true;
      });
  }

  handlePaymentCallback(): void {
    if (this.data.mode !== 'callback') {
      return;
    }
    this.loading=false;
    this.bulkPurchaseService
      .confirmPaymentSession(
        this.data.eventId||0,
        this.data.eventType,
        this.data.sessionId
      )
      .subscribe(
        {
        next: (res) => {
          this.paymentResponse = res;
          if(this.data.puchaseType!='subscription' && res.guestUserIds){
            for (let userId of res.guestUserIds.split(',')) {
              this.userService.getUserDetails(+userId).subscribe({
                next: (user) => {
                  this.ticketGuests.push(user);
                  this.error=false;
                  console.log(user,'======= usre pushed =============');
                },
                error: (error) => {

                  console.log(
                    '-----------error while pushing user  -----------',error,this.ticketGuests);
                },
              });
            }
          }
          // this.error=false;
        },
        error: (err)=>{
                this.isConfirmationError = true;
        }
      });
  }

  reloadPage(){
    window.location.reload();
  }
  getUserDetails() {
    this.loading = true;
    this.spotlightService
      .getUserDetails()
      .toPromise()
      .then((res: any) => {
        this.userDetails = res;
        res['userId'] = res.userID ? res.userID : res.userId;
        localStorage.setItem('userData', JSON.stringify(res));
      })
      .catch(console.error);
  }
   openMyTicket(): void {
        this.closeConfirmationDialog()
          this.router.navigate(['/cinejoy/premiere/lineup']);
          const modalRef = this.modalService.open(MyTicketsComponent, { size: 'lg', backdrop: 'static' });
          
  }
}
